<div class="person-card-container" [style.background-image]="'url(' + normalizedPerson.pictureUrl + ')'">

  <div class="person-card-picture-placeholder" *ngIf="!normalizedPerson.pictureUrl"><mat-icon>no_accounts</mat-icon></div>

  <div class="person-card-bottom-bar">
    <div class="person-main-info">
      <div class="person-name">{{ normalizedPerson.normalizedName }}</div>
      <div class="person-age">
        <span *ngIf="normalizedPerson.age">{{ normalizedPerson.age }} anos</span>
      </div>
    </div>
    <div class="person-actions">
      <button
        mat-icon-button
        *ngIf="actions?.includes(PersonsListItemActionType.SEND_SMS)"
        (click)="callAction(PersonsListItemActionType.SEND_SMS)"
      >
        <mat-icon>sms</mat-icon>
      </button>
      <button
        mat-icon-button
        *ngIf="actions?.includes(PersonsListItemActionType.CALL)"
        (click)="callAction(PersonsListItemActionType.CALL)"
      >
        <mat-icon>call</mat-icon>
      </button>
      <button
        mat-icon-button
        *ngIf="actions?.includes(PersonsListItemActionType.OPEN)"
        (click)="callAction(PersonsListItemActionType.OPEN)"
      >
        <mat-icon>account_box</mat-icon>
      </button>
    </div>
  </div>
</div>
